module.exports = __webpack_public_path__ + "img/Exhibition_Logo2.395cfc1d.jpg";